import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Upload, Plus } from 'lucide-react';
import { toast } from 'sonner';
interface AddMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function AddMemberModal({
  isOpen,
  onClose
}: AddMemberModalProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      onClose();
      toast.success('Welcome to the family', {
        style: {
          background: '#2a201c',
          color: '#f5ede1',
          border: '1px solid #3d302a'
        }
      });
    }, 800);
  };
  return <AnimatePresence data-id="element-15">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-16" />
          <motion.div initial={{
        opacity: 0,
        y: 100,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 100,
        scale: 0.95
      }} className="fixed inset-x-4 bottom-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 z-50 bg-warm-surface border border-warm-border rounded-3xl p-6 shadow-warm md:w-full md:max-w-md" data-id="element-17">
            <div className="flex items-center justify-between mb-6" data-id="element-18">
              <h2 className="text-2xl font-serif text-warm-text" data-id="element-19">
                Add Family Member
              </h2>
              <button onClick={onClose} className="p-2 text-warm-muted hover:text-warm-text transition-colors bg-warm-bg rounded-full" data-id="element-20">
                <X className="w-5 h-5" data-id="element-21" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-22">
              <div className="flex justify-center mb-6" data-id="element-23">
                <div className="w-24 h-24 rounded-full border-2 border-dashed border-warm-border flex flex-col items-center justify-center text-warm-muted hover:text-warm-cyan hover:border-warm-cyan transition-colors cursor-pointer bg-warm-bg" data-id="element-24">
                  <Upload className="w-6 h-6 mb-2" data-id="element-25" />
                  <span className="text-xs" data-id="element-26">Photo</span>
                </div>
              </div>

              <div data-id="element-27">
                <label className="block text-sm text-warm-muted mb-1" data-id="element-28">
                  Full Name
                </label>
                <input required type="text" className="w-full bg-warm-bg border border-warm-border rounded-xl px-4 py-3 text-warm-text focus:outline-none focus:border-warm-cyan transition-colors" placeholder="e.g. Maya Sharma" data-id="element-29" />
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-30">
                <div data-id="element-31">
                  <label className="block text-sm text-warm-muted mb-1" data-id="element-32">
                    Relation
                  </label>
                  <input required type="text" className="w-full bg-warm-bg border border-warm-border rounded-xl px-4 py-3 text-warm-text focus:outline-none focus:border-warm-cyan transition-colors" placeholder="e.g. Sister" data-id="element-33" />
                </div>
                <div data-id="element-34">
                  <label className="block text-sm text-warm-muted mb-1" data-id="element-35">
                    Birth Year
                  </label>
                  <input required type="text" className="w-full bg-warm-bg border border-warm-border rounded-xl px-4 py-3 text-warm-text focus:outline-none focus:border-warm-cyan transition-colors" placeholder="e.g. 1995" data-id="element-36" />
                </div>
              </div>

              <div data-id="element-37">
                <label className="block text-sm text-warm-muted mb-1" data-id="element-38">
                  Short Bio
                </label>
                <textarea rows={3} className="w-full bg-warm-bg border border-warm-border rounded-xl px-4 py-3 text-warm-text focus:outline-none focus:border-warm-cyan transition-colors resize-none" placeholder="A brief memory or description..." data-id="element-39" />
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full mt-4 bg-warm-cyan text-warm-bg font-medium py-3 rounded-xl hover:bg-opacity-90 transition-all flex items-center justify-center gap-2" data-id="element-40">
                {isSubmitting ? <motion.div animate={{
              rotate: 360
            }} transition={{
              repeat: Infinity,
              duration: 1,
              ease: 'linear'
            }} data-id="element-41">
                    <Plus className="w-5 h-5" data-id="element-42" />
                  </motion.div> : <>
                    <Plus className="w-5 h-5" data-id="element-43" />
                    Add to Tree
                  </>}
              </button>
            </form>
          </motion.div>
        </>}
    </AnimatePresence>;
}